import {
    AfterViewInit,
    Component,
    ElementRef,EventEmitter,
    HostListener,
    Input, Output,
    OnInit,
    SecurityContext,
    ViewChild
} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {SearchPageData, SolrOptionsEntityDTO} from "@signature-it/ngx-entity/models";
import {SearchService, SolrEntityService} from "@signature-it/ngx-entity/services";
import {UntypedFormControl} from "@angular/forms";
import {
    AccessibilityService, LanguageService, ShareDataService, SolrService, FeaturesService, GoogleAnalyticsService
} from "@signature-it/ngx-generic/services";
import {ISearchSection, ILanguage} from '@signature-it/ngx-generic/interfaces';
import {forkJoin, Observable, Subscription, asapScheduler} from "rxjs";
import {debounceTime, finalize, switchMap, take, tap} from "rxjs/operators";
import {NavigationStart, Router} from "@angular/router";
import {EntityConfig, GenericConfig, RestUrlsConfig} from '@signature-it/ngx-generic/config';
import {Store} from "@ngrx/store";
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';

declare var _: any;
@Component({
    selector: 'search',
    templateUrl: './e-search-page-input.component.html',
    styleUrls: ['./e-search-page-input.component.scss'],
    standalone: false
})
export class ESearchPageInputComponent implements OnInit, AfterViewInit {
    searchPageData: SearchPageData;
    @Input() redirectSearchUrl: string = '';
    @Input() idInputToFous: string;
    @Input() key;
    @Input() exactMatch: boolean = false;
    @Input() enableExactMatch: boolean = false;
    @Input() buttonClasses = '';
    @Input() listTitle = '';
    @Input() ariaDescribedby = '';
    @Input() limitResults: number;
    @Input() autocompleteLengthStartSearch: number = 1;
    @Input() autocompleteNoResultsBlockVar: string = '';
    @Input() placeholderInput = 'Header Entity...';
    enableTaxonomySubjectSearch: boolean;
    taxonomySubjectSearchVar: string;
    selectedOnMenuByName: string;
    langCode: string;
    kw: string;
    searchSectionsCtrl = new UntypedFormControl();
    isLoading = false;
    searchList = null;
    isOpen: boolean = false;
    activeFilters = {};
    subscriptionsList$: Array<Subscription> = [];
    flagNoOpenResults: boolean = false;
    keyBoardFunc: Function = () => {
    }
    @ViewChild('btnContent') btnContent: ElementRef;
    shouldAriaLabel: boolean = true;
    entityConfig;
    commonSearches: any;
    results: any = [];
    locationChanged = false;
    splitRow: boolean = GenericConfig.splitAutoCompleteSearchResults === false ? false : true;
    templates$;
    @Input() searchPlaceholder: string = 'Header Search...';
    @Output() searchBtnClicked = new EventEmitter<boolean>();
    @Input() clearKeyAfterSearch: boolean = false;
    @Input() type: string = GenericConfig.isDam ? 'media' : 'catalogue';
    @Input() autocompleteNgram: boolean;
    @Input() searchSections;
    @Input() positionClose: string;
    static readonly COMMON_SEARCH_TYPES = ['common_search', 'custom'];

    constructor(
        protected solrEntityService: SolrEntityService,
        protected solrService: SolrService,
        protected langSvc: LanguageService,
        public shareSvc: ShareDataService,
        public el: ElementRef,
        protected searchService: SearchService,
        public router: Router,
        protected featuresService: FeaturesService,
        public restUrlsConf: RestUrlsConfig,
        protected analyticsSvc: GoogleAnalyticsService,
        protected accessibilitySvc: AccessibilityService,
        protected store$: Store<any>) {
        this.langSvc.getCurrentLanguage$().pipe(take(2)).subscribe((lang: ILanguage) => {
            this.langCode = lang.code;
        });
        this.keyBoardFunc = this.accessibilitySvc.addArrowNavigation('.autocomplete-results-wrapper', 'li', '.item-num-', 'a', false, true);
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                // to avoid opening the results section when the url is changed
                this.locationChanged = true;
            }
        });
        this.templates$ = this.store$.select(EntitySelectors.getPreviews);

    }

    setConfig() {
        // this.searchPageData = this.searchService.getSearchPageData(this.key) ;
        this.enableTaxonomySubjectSearch = (this.searchPageData && this.searchPageData.enableTaxonomySubjectSearch) || false;
        this.taxonomySubjectSearchVar = (this.searchPageData && this.searchPageData.taxonomySubjectSearchVar) || '';
        this.searchSections = this.searchSections || (this.searchPageData && this.searchPageData.searchSections) || GenericConfig.searchSections;
        this.autocompleteNgram = this.autocompleteNgram || (this.searchPageData && this.searchPageData.autocompleteNgram) || false;
        this.redirectSearchUrl = this.redirectSearchUrl || (this.searchPageData && this.searchPageData.redirectSearchUrl) || null;
        this.selectedOnMenuByName = this.selectedOnMenuByName || (this.searchPageData && this.searchPageData.selectedOnMenuByName) || '';
        this.positionClose = this.positionClose || (this.searchPageData && this.searchPageData.positionClose) || 'start';
        this.autocompleteNoResultsBlockVar = this.autocompleteNoResultsBlockVar || this.searchPageData?.autocomplete?.['noResultsBlockVar'];
    }

    ngOnInit() {
        this.store$.dispatch(EntityActions.getPreviews());
        this.searchPageData = this.searchService.getSearchPageData(this.key);
        this.setConfig();
        if (this.autocompleteNgram) {
            if (!this.searchSections) return;
            this.searchSections = this.searchSections.filter(s => s.active);
            this.searchSectionsCtrl.valueChanges
                .pipe(
                    debounceTime(500),
                    tap(() => {
                        if(!this.searchSectionsCtrl.value.length) {
                            this.results = [];
                        }
                        this.isLoading = true;
                    }),
                    switchMap(value => this.getAutocompleteRes(value)
                        .pipe(
                            finalize(() => {
                                this.isLoading = false;
                            }),
                        )
                    )
                )
                .subscribe(data => {
                    this.results = data;
                    this.isLoading = false;
                    this.setIsLast();

                    if ((this.results.length || this.autocompleteNoResultsBlockVar) && !this.locationChanged) {
                        this.isOpen = true;
                    }
                    this.locationChanged = false;
                });
        } else if (this.searchPageData.autocomplete) {
            this.searchSectionsCtrl.valueChanges
                .pipe(
                    debounceTime(500),
                    tap(() => {
                        this.searchList = [];
                        this.isOpen = false;
                    }),
                    switchMap(value => this.getSearch()
                        .pipe(
                            finalize(() => {
                            }),
                        )
                    )
                )
                .subscribe(data => {
                    this.searchList = data;
                    if (this.searchList.length || (this.autocompleteNoResultsBlockVar && this.searchSectionsCtrl.value)) {
                        this.isOpen = true;
                    }
                });
        }
        this.updateSearchPageData();
    }

    ngAfterViewInit() {
        if (this.btnContent && this.btnContent.nativeElement.innerText.trim()) {
            this.shouldAriaLabel = false;
        }
    }

    private getAutocompleteRes(value) {
        const subscriptions = {};
        return new Observable((observer) => {
            if (!value || this.flagNoOpenResults) {
                this.flagNoOpenResults = false;
                return observer.next([]);
            }
            this.searchSections.forEach(section => {
                const isCSType = ESearchPageInputComponent.COMMON_SEARCH_TYPES.indexOf(section.type) !== -1;

                if (section.type !== 'ShowAllResults' && !isCSType) {
                    subscriptions[section.type] = this.solrService.ngramRequest( value, section, 10, section.fq, true, false, section.type_i || 1);
                }
                if (section.isFixed && isCSType) {
                    subscriptions[section.type] = this.getCommonSearchData(section.type);
                }
            });
            forkJoin(subscriptions).subscribe(data => {
                return observer.next(this.getGroups(data));
            });
        });
    }
    private getCommonSearchData(type?) {
        return new Observable(observer => {
            if (this.commonSearches) {
                observer.next(this._getCSMappedData(type));
                observer.complete();
                return;
            }
            this.featuresService.getCommonSearches(this.langCode).subscribe(res => {
                this.commonSearches = res;
                observer.next(this._getCSMappedData(type));
                observer.complete();
            });
        })
    }

    private _getCSMappedData(type) {
        const csSections = this.searchSections.filter(s => ESearchPageInputComponent.COMMON_SEARCH_TYPES.indexOf(s.type) > -1);
        const data = {};
        csSections.forEach(s => {
            if (!type || type && s.type === type) {
                data[s.type] = {
                    items: this.commonSearches.filter(cs => s.type === cs.type)
                };
            }
        });
        if (type) {
            return data[type];
        } return data;
    }

    private getGroups(data) {
        const groups = [];
        const orderField = this.shareSvc.isMobileMode() ? 'orderMobile' : 'order';
        Object.keys(data).forEach(type => {
            const section = this.searchSections.filter(s => s.type === type)[0];
            let value: any;
            value = data[type];
            let items = [];
            if (value['grouped']) {
                const groupBy = section['groupBy'];
                if (groupBy) {
                    items = value['grouped'][groupBy]['groups'].map(g => {
                        return g['doclist']['docs'][0];
                    });
                }
            } else if (value['items']) { // for common search data
                items = value['items'];
            } else {
                items = section.type == 'facet' && value['facet_counts'] ? value['facet_counts']['facet_fields'][section.facetField] : value['response']['docs'];
            }

            section.order = section[orderField];
            if (items.length) {
                section['items'] = items;
                groups.push(section);
            }
        });
        if (groups.length) this.getShowAllSection(groups);
        return _.sortBy(groups, 'order');
    }

    getShowAllSection(groups) {
        let showAll = this.searchSections.filter(s => s.type === 'ShowAllResults');
        if (showAll.length) {
            groups.push(showAll[0]);
        }
        return;
    }

    private setIsLast() {
        const resLength = this.results.length;
        if (resLength) {
            let item = this.results[resLength - 1].items;
            if (item) {
                const itemsLength = this.results[resLength - 1].items.length;
                if (itemsLength) {
                    this.results[resLength - 1].items[itemsLength - 1].isLast = true;
                }
            }
        }
    }

    searchAuto() {
        // if (!val) return;
        // this.key = val;
        if(GenericConfig.gaSendSearchTerms)
            this.analyticsSvc.sendSearchTerm(this.key);
        this.router.navigate([`${this.type}/group/1`], { queryParams: {kw: this.key || '*'}});

        if (this.clearKeyAfterSearch) {
            this.key = '';
        }
        this.searchBtnClicked.emit(true);
        this.isOpen = false;
    }

    setKey(val) {
        if (!val) return;
        this.key = val;
        this.searchAuto();
    }
    optionSelectedFunc(attr, item) {
        if(attr['noLink']) {
            return;
        }
        let route;
        let queryParams = {};
        switch (attr['type']) {
            case 'products':
                let productPageUrlField = GenericConfig.productPageUrlField ? GenericConfig.productPageUrlField : 'product_id_i';
                route =  `/product-page/${encodeURIComponent(item[productPageUrlField])}`;
                break;
            case 'brands':
                route = `catalogue/group/1`;
                queryParams['BrandName_ss']  = item['BrandName_ss'][0];
                break;
            case 'categories':
                route = `catalogue/group/${item['group_id_i']}`;
                break;
            default: // for common search - multiple types
                route = item['redirect_url'].split('?')[0];
                queryParams = this.router.parseUrl(item['redirect_url']).queryParams;
                break;
        }
        this.isOpen = false;
        this.router.navigate([route], {queryParams});
        this.searchBtnClicked.emit(true);
    }
    onFocus() {
        this.getCommonSearchData().subscribe(res => {
            if (res) {
                this.results = this.getGroups(res);
                if (this.results.length) {
                    this.isOpen = true;
                    this.setIsLast();
                }
            }
        })
    }

    onFocusOut(item) {
        if (item.isLast) {
            this.isOpen = false;
        }
    }
    private getSearch() {
        return new Observable((observer) => {
            if (!this.searchSectionsCtrl.value || this.searchSectionsCtrl.value.length < this.autocompleteLengthStartSearch || this.flagNoOpenResults) {
                this.flagNoOpenResults = false;
                observer.next([]);
                observer.complete();
                return
            }
            var searchTerm = '';
            if (this.exactMatch) {
                searchTerm = '"' + this.searchSectionsCtrl.value.replace(/"/g, '\\"') + '"';
            }
            else{
                searchTerm = this.searchSectionsCtrl.value;
            }
            const solrOptions = new SolrOptionsEntityDTO({
                search: searchTerm,
                searchFields: this.searchPageData.autocomplete['searchFields'],
                productType: this.searchPageData.productTypes,
                extraQryString: this.searchPageData.solrQueryParams + (this.searchPageData.autocomplete['solrQueryParams'] || ''),
                itemsPerPage: this.limitResults
            });
            this.solrEntityService.getSolr(solrOptions).subscribe(
                solrResponse => {
                    const docs = solrResponse.response.docs;
                    observer.next(docs);
                    observer.complete();
                    return;
                }
            );

        });
    }

    onChangeMenuSubjectSearch(data) {
        this.redirectSearchUrl = data;
    }

    search() {
        if (this.exactMatch && this.searchSectionsCtrl.value.length) {
            this.kw = '"' + this.searchSectionsCtrl.value + '"';
        } else {
            switch (this.searchPageData.likeMode) {
                case 'both':
                    this.kw = '*' + this.searchSectionsCtrl.value.split(' ').join('* *') + '*';
                    break;
                case 'before':
                    this.kw = '*' + this.searchSectionsCtrl.value.split(' ').join(' *');
                    break;
                case 'after':
                    this.kw = this.searchSectionsCtrl.value.split(' ').join('* ') + '*';
                    break;
                default:
                    this.kw = this.searchSectionsCtrl.value;
            }
        }
        if (this.redirectSearchUrl) {
            this.isOpen = false;
            if (this.redirectSearchUrl.indexOf('?') !== -1 && this.redirectSearchUrl.indexOf('=') !== -1) {
                let queryParams = new Object();
                let route = this.redirectSearchUrl.split('?')[0];
                queryParams = this.router.parseUrl(this.redirectSearchUrl).queryParams;
                queryParams = Object.assign({}, queryParams, {kw: this.kw});
                if (route && route != '') {
                    this.router.navigate([route], {queryParams});
                } else {
                    this.isOpen = false;
                    this.searchPageData.kw = this.kw;
                    this.searchPageData.page = 1;
                    queryParams = Object.assign({}, queryParams, {page: 1});
                    this.searchService.addUrlParam(queryParams, this.key);
                }
            } else {
                this.router.navigate([this.redirectSearchUrl], {queryParams: {kw: this.kw}});
            }
        } else {
            this.isOpen = false;
            this.searchPageData.kw = this.kw;
            this.searchPageData.page = 1;
            this.searchService.addUrlParam({kw: this.kw, page: 1}, this.key);
        }
    }

    updateSearchPageData(){
        this.subscriptionsList$.push(this.searchService.updateSearchPageData.subscribe((key) => {
            if (key == this.key) {
                this.activeFilters = {...this.searchPageData.activeFilters};

                if (this.exactMatch && this.searchPageData.kw.charAt(0) == '"' && this.searchPageData.kw.charAt(this.searchPageData.kw.length - 1)) {
                    this.searchSectionsCtrl.setValue(this.searchPageData.kw.substring(1, this.searchPageData.kw.length - 1));
                } else {
                    switch (this.searchPageData.likeMode) {
                        case 'both':
                            this.searchSectionsCtrl.setValue(this.searchPageData.kw.split(' ').map(k => k.substring(1, k.length - 1)).join(' '));
                            break;
                        case 'before':
                            this.searchSectionsCtrl.setValue(this.searchPageData.kw.split(' ').map(k => k.substring(1, k.length)).join(' '));
                            break;
                        case 'after':
                            this.searchSectionsCtrl.setValue(this.searchPageData.kw.split(' ').map(k => k.substring(k.length - 1, 0)).join(' '));
                            break;
                        default:
                            this.searchSectionsCtrl.setValue(this.searchPageData.kw);
                    }
                }
                this.flagNoOpenResults = true;
            }
        }));
    }

    // onFocus() {
    //     this.isOpen = false;
    // }

    @HostListener('document:click', ['$event']) onClinkOutside(event: any) {
        if (!this.el.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }

    createDictionarySearch(item) {
        this.isOpen = false;
        let params = {
            'entity_var_s': item.entity_var_s,
            [this.searchPageData.dictionarySolrKey]: (this.searchPageData.searchLayoutMode == 'tab') ? item[this.searchPageData.dictionarySolrKey] : null
        };
        this.searchService.addUrlParam(params, this.key, item.entity_var_s);
    }

    handleKeydown(event) {
        const UP = 38;
        const DOWN = 40
        if (event.keyCode == UP || event.keyCode == DOWN) {
            this.accessibilitySvc.setFocusOnTab('.autocomplete-results-wrapper li:first-child a', 0);
        }
    }

    onExactMatchChange(event) {
        this.exactMatch = event.checked;
    }
}
